import { render } from "./RadioButton.vue?vue&type=template&id=aefe04a0&ts=true"
import script from "./RadioButton.ts?vue&type=script&lang=ts&external"
export * from "./RadioButton.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__